import { Box } from '@mui/material';
import { useEffect } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { isJobRunning, jobQueueState } from '~/state/atoms/jobAtoms';
import { selectedPatientIdState } from '~/state/atoms/patientAtoms';
import { currentStructureSetState } from '~/state/atoms/structureSet/structureSetAtoms';
import { WorkflowTypes, workflowModalState } from '~/state/atoms/viewerAtoms';
import AiAssistantButton from '../../AiAssistantButton';
import DatasetPicker from '../ContouringStep/DatasetPicker/DatasetPicker';
import StructureSet from '../ContouringStep/StructureSet/StructureSet';
import StepHeader from '../StepHeader';
import { useCurrentDose } from '~/hooks/dose/useCurrentDose';

export default function DoseContent() {
    const selectedPatientId = useRecoilValue(selectedPatientIdState);
    const currentDose = useCurrentDose();
    const currentStructureSet = useRecoilValue(currentStructureSetState);
    const setWorkflowModal = useSetRecoilState(workflowModalState);
    const jobQueue = useRecoilValue(jobQueueState);
    const hasActiveTasks = jobQueue.jobs.some((job) =>
        isJobRunning(job.status)
    );

    useEffect(() => {
        if (selectedPatientId && !currentDose && !hasActiveTasks) {
            setWorkflowModal((state) => ({
                ...state,
                open: true,
                page: WorkflowTypes.DOSE,
            }));
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <Box
            height="100%"
            position="relative"
            display="grid"
            gridTemplateRows="auto 1fr"
            gridTemplateColumns="minmax(0, 1fr)"
        >
            <Box>
                <StepHeader titleId="workflow.dose" />
                <Box px={2} mt={1} mb={1.5}>
                    <AiAssistantButton page={WorkflowTypes.DOSE} />
                </Box>
                <Box px={2}>
                    <DatasetPicker />
                </Box>
            </Box>
            {selectedPatientId && currentStructureSet && (
                <Box height="100%" display="grid">
                    <StructureSet structureSet={currentStructureSet} readOnly />
                </Box>
            )}
        </Box>
    );
}
